/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowGameShowTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowGameShow,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Play for Prizes!",
    "Game Show Night Awaits!",
    "Who Will Win?",
  ],
  title: "Game Show Night",
  description: "Organize an exciting game show night.",
  longDescription:
    "Gather your friends for a competitive game show night! Choose a date, decide on games to play, and plan prizes for the winners!",
  emoji: "🎤",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Game Show Night",
          emoji: "🎤",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the game show night?",
          emoji: "📅",
          completeAction: {
            question: "Decide on games to play?",
            description: "What games do we want to include in the game show?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What games should we choose?",
                emoji: "🎲",
                completeAction: {
                  question: "Decide on prizes?",
                  description: "What prizes should we offer for the winners?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What prizes should we have?",
                      emoji: "🏆",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let the Games Begin!",
    outroDescription:
      "Your game show night plans are set! Enjoy the excitement!",
  },
};
